export default __webpack_public_path__ + "static/media/n8.57bbced1.svg";